export default __webpack_public_path__ + "01100ee21ff41693297ac12ea94a8ddd.svg";